var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransformPositionActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.15332 5.99967V4.33301C2.15332 2.67301 3.49332 1.33301 5.15332 1.33301H6.81999",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8198 1.33301H12.4865C14.1465 1.33301 15.4865 2.67301 15.4865 4.33301V5.99967",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4863 10.667V11.667C15.4863 13.327 14.1463 14.667 12.4863 14.667H11.4863",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81999 14.6667H5.15332C3.49332 14.6667 2.15332 13.3267 2.15332 11.6667V10",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8198 8.00033V6.66699M4.81982 8.00033H8.81982H12.8198H4.81982ZM4.81982 8.00033V6.66699V8.00033ZM4.81982 8.00033V9.33366V8.00033ZM12.8198 8.00033V9.33366V8.00033Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81966 4H10.153M8.81966 12V4V12ZM8.81966 12H10.153H8.81966ZM8.81966 12H7.48633H8.81966ZM8.81966 4H7.48633H8.81966Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransformPositionActive);
export default __webpack_public_path__ + "static/media/transform_position_active.d389f8b5e06097db7bcbeb9387f4efbc.svg";
export { ForwardRef as ReactComponent };